import { render, staticRenderFns } from "./MySnackBar.vue?vue&type=template&id=23f4eace&scoped=true&"
import script from "./MySnackBar.vue?vue&type=script&lang=js&"
export * from "./MySnackBar.vue?vue&type=script&lang=js&"
import style0 from "./MySnackBar.vue?vue&type=style&index=0&id=23f4eace&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23f4eace",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VLayout } from 'vuetify/lib/components/VGrid';
import { VSnackbar } from 'vuetify/lib/components/VSnackbar';
installComponents(component, {VIcon,VLayout,VSnackbar})
